import { FC, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import "react-html5-camera-photo/build/css/index.css";
import { Dialog, Transition } from "@headlessui/react";
import success from "../../assets/svg/success.svg";
import error from "../../assets/svg/error.svg";
import {
  XIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/solid";
interface OpenCameraProps {
  isOpen?: boolean;
  closeAction?: Function;
  type?: boolean;
  message?: any;
  subMessage?: any;
}
const BeforeAbsence: FC<OpenCameraProps> = (props): JSX.Element => {
  const history = useNavigate();

  const getIcon = () => {
    if (props.type === true) {
      return <CheckCircleIcon className="w-1/2 h-1/2 text-green-400" />;
    } else if (props.type === false) {
      return <ExclamationCircleIcon className="w-1/2 h-1/2 text-red-400" />;
    }
  };
  return (
    <>
      <Transition appear show={props.isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => props.closeAction}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900 flex justify-center"
                  >
                    {getIcon()}
                    {/* <img
                      src={props.type ? success : error}
                      alt="alert"
                      width={"50%"}
                      className="mx-auto"
                    /> */}
                  </Dialog.Title>
                  <div className="mt-2 flex justify-center">
                    <p className="text-lg font-bold text-black">
                      {props.message}
                    </p>
                  </div>
                  <div className="mt-2 flex justify-center">
                    <p className="text-sm text-black">{props.subMessage}</p>
                  </div>

                  <div className="mt-4 flex justify-end">
                    <button
                      type="button"
                      className="active:bg-zinc-100 inline-flex  rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => props.closeAction()}
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default BeforeAbsence;
